module.exports = __webpack_public_path__ + "img/ENGENHARIA-thumb.72e2a87d.png";